import React from 'react'
import { FocusableComponentLayout } from '@noriginmedia/norigin-spatial-navigation'
import tts from '../../lib/TTS'
import passportImg from '../../assets/img/passportLogo.svg'
import FocusableLink from '../../components/FocusableLink/index.ts'
import { PassportLinkProps } from './types'

const PassportLink = ({
  focusKey,
  isActive,
  label,
  onFocus,
  stationName,
  to,
}: PassportLinkProps) => {
  const membershipStatus = isActive ? 'ACTIVE' : 'BECOME A MEMBER'

  const handleFocus = (
    layout: FocusableComponentLayout,
    props: any,
    details: any
  ) => {
    tts.stopRead()
    tts.addTextToRead(`Focused on ${label}. ${membershipStatus}`)

    onFocus?.(layout, props, details)
  }

  return (
    <FocusableLink
      focusKey={focusKey}
      label={label}
      to={to}
      onFocus={handleFocus}
      disableTTS
    >
      <div className="passport-container">
        <span className="passport-text">{stationName}</span>
        <img alt="Passport Logo" className="passport-image" src={passportImg} />
        <span className="passport-text">Passport</span>
        <p className="passport-status">{membershipStatus}</p>
      </div>
    </FocusableLink>
  )
}

export default PassportLink
